// API Configuration
// Production API runs on the Coolify server, same host as the site.
// Render was retired - do NOT reintroduce aof-backend.onrender.com as a
// fallback: that hostname now returns 404, so a missing REACT_APP_API_URL
// would fail silently instead of loudly.
const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.abrahamoladotunfoundation.org'
    : 'http://localhost:5000');

export const apiConfig = {
  baseURL: API_BASE_URL,
  endpoints: {
    donations: `${API_BASE_URL}/api/donations`,
    auth: `${API_BASE_URL}/api/auth`,
    volunteers: `${API_BASE_URL}/api/volunteers`,
    contacts: `${API_BASE_URL}/api/contacts`,
    newsletter: `${API_BASE_URL}/api/newsletter`,
    events: `${API_BASE_URL}/api/events`,
    gallery: `${API_BASE_URL}/api/gallery`,
    images: `${API_BASE_URL}/api/images`,
    children: `${API_BASE_URL}/api/children`,
    classes: `${API_BASE_URL}/api/classes`,
    meetings: `${API_BASE_URL}/api/meetings`,
    tasks: `${API_BASE_URL}/api/tasks`,
    admin: `${API_BASE_URL}/api/admin`,
    sponsorships: `${API_BASE_URL}/api/sponsorships`,
    volunteerTasks: `${API_BASE_URL}/api/volunteer-tasks`,
    initiatives: `${API_BASE_URL}/api/initiatives`,
    programs: `${API_BASE_URL}/api/programs`,
    pages: `${API_BASE_URL}/api/pages`,
    childRequests: `${API_BASE_URL}/api/child-requests`,
    donationCauses: `${API_BASE_URL}/api/donation-causes`,
    widows: `${API_BASE_URL}/api/widows`,
    staffAttendance: `${API_BASE_URL}/api/staff-attendance`,
    staff: `${API_BASE_URL}/api/staff`
  }
};

// Helper function to make API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = (endpoint && typeof endpoint === 'string' && endpoint.startsWith('http')) ? endpoint : `${API_BASE_URL}${endpoint || ''}`;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  };

  const response = await fetch(url, { ...defaultOptions, ...options });
  return response;
};

export default apiConfig;
